import { FreshServiceProposalWash, PriceUtils } from "@repo/common"
import { MessageSquareText, ShowerHead } from "lucide-react"
import * as React from "react"
import { Body } from "../../components/ui/typography"
import {
  SelectableCard,
  SelectableCardContent,
  SelectableCardDescription,
  SelectableCardHeader,
  SelectableCardIcon,
  SelectableCardIndicator,
  SelectableCardPrice,
  SelectableCardTitle,
} from "./selectable-card"

interface ServiceProposalWashCardProps {
  data: FreshServiceProposalWash
  selected: boolean
  onSelect: () => void
  interactive?: boolean
  className?: string
  hidePrice?: boolean
  variant?: "checkbox" | "radio"
  comment?: string | null
}

const ServiceProposalWashCard = React.forwardRef<
  HTMLDivElement,
  ServiceProposalWashCardProps
>(
  (
    {
      className,
      data,
      selected,
      onSelect,
      interactive = true,
      hidePrice = false,
      variant = "checkbox",
      comment,
    },
    ref,
  ) => {
    const shouldDimContent = !selected

    return (
      <SelectableCard
        ref={ref}
        className={className}
        selected={selected}
        onSelect={onSelect}
        interactive={interactive}
        color="secondary"
        variant={variant}
      >
        <SelectableCardHeader>
          <div className="flex items-center gap-1">
            <SelectableCardTitle>{data.name}</SelectableCardTitle>
            <SelectableCardIcon>
              <ShowerHead />
            </SelectableCardIcon>
          </div>
          <SelectableCardIndicator />
        </SelectableCardHeader>
        <SelectableCardContent>
          {!hidePrice && (
            <SelectableCardPrice
              className={shouldDimContent ? "opacity-40" : ""}
            >
              {PriceUtils.format(PriceUtils.getWashPrice(data))}
            </SelectableCardPrice>
          )}
          {data.description && (
            <SelectableCardDescription
              className={shouldDimContent ? "opacity-40" : ""}
            >
              {data.description}
            </SelectableCardDescription>
          )}
          {comment && (
            <div className="flex items-start gap-2">
              <MessageSquareText className="size-4 text-foreground flex-shrink-0 mt-0.5" />
              <Body size="s" className="text-foreground">
                {comment}
              </Body>
            </div>
          )}
        </SelectableCardContent>
      </SelectableCard>
    )
  },
)

ServiceProposalWashCard.displayName = "ServiceProposalWashCard"

export { ServiceProposalWashCard, type ServiceProposalWashCardProps }
